import '@angular/common/locales/global/nl-BE'
import {Component, OnDestroy, OnInit} from '@angular/core'


@Component({
  selector: 'app-add-user-wrapper',
  templateUrl: './add-user-wrapper.component.html',
  styleUrls: ['./add-user-wrapper.component.scss']
})
export class AddUserWrapperComponent {

}

